import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, ViewController } from 'ionic-angular';
import {ProofProvider} from "../../providers/proof/proof";

/**
 * Generated class for the PopovercomponentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popovercomponent',
  templateUrl: 'popovercomponent.html',
})
export class PopovercomponentPage {
  links: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public popover: PopoverController, public viewCtrl: ViewController,     private proofProvider: ProofProvider,) {
    this.links = proofProvider.getProofLinks();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PopovercomponentPage');
  }
  ClosePopover()
  {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/popovercomponent/popovercomponent.ts